export { Dialog } from './Dialog';
export type { Props } from './Dialog.types';
